// Derive presentation from the existing View and its preserved sources. Layout
// never changes the saved narrative, source selection or reading order.
import { richBlockById } from '../data/viewRichBlocks.js';

function selectedLength(block, source) {
  const parts = source?.parts || [];
  const selected = block.part_indices?.length
    ? block.part_indices.map(index => parts[index] || '')
    : parts;
  return selected.join(' ').length;
}

export function viewSourceLayout(block, source) {
  if (!source || block?.kind !== 'source') return 'reading';
  const presentation = block.presentation || 'excerpt';
  const kind = source.entity?.kind || source.view_kind;
  if (block.prominence === 'feature' && ['media', 'component', 'card'].includes(presentation)) return 'wide';
  if (presentation === 'interactive' || presentation === 'embed') {
    // Full applications, maps and charts need room for their own controls.
    const component = richBlockById(block.source_id)?.component;
    return ['AboutAiEntry', 'ViewComposeInvitation'].includes(component) ? 'paired' : 'wide';
  }
  if (presentation === 'component') {
    if (kind === 'fragment') return 'paired';
    return 'wide';
  }
  if (presentation === 'media') return (source.media?.length || 0) > 1 ? 'wide' : 'paired';
  if (['cite', 'quote', 'excerpt', 'card'].includes(presentation)) {
    return selectedLength(block, source) <= 800 ? 'paired' : 'reading';
  }
  return 'reading';
}

export function layoutViewSection(section, sourceFor) {
  const blocks = section?.blocks || [];
  const rows = [];
  for (let index = 0; index < blocks.length; index += 1) {
    const block = blocks[index];
    const next = blocks[index + 1];
    const source = next?.kind === 'source' ? sourceFor(next.source_id) : null;
    const nextLayout = source ? viewSourceLayout(next, source) : 'reading';
    const connected = !block.source_ids?.length || block.source_ids.includes(next?.source_id);
    if (block.kind === 'bridge' && connected && nextLayout === 'paired') {
      rows.push({ type: 'paired', items: [{ block, index }, { block: next, index: index + 1 }] });
      index += 1;
    } else {
      const layout = block.kind === 'source' ? viewSourceLayout(block, sourceFor(block.source_id)) : 'reading';
      rows.push({ type: layout === 'wide' ? 'wide' : 'reading', items: [{ block, index }] });
    }
  }
  return rows;
}
